export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  Long: number;
  _Any: any;
  _FieldSet: any;
};

export type ProductFeature = {
  enabled: boolean;
};

export type QuantityLimitedProductFeature = {
  enabled: boolean;
  limit: Scalars['Int'];
}

export type DeskFeatures = {
  enabled: boolean;

  unlimitedDesks(locationId: Scalars['ID']): QuantityLimitedProductFeature;

  permanentAssignment(locationId: Scalars['ID']): ProductFeature;

  neighborhood(locationId: Scalars['ID']): ProductFeature;

  amenities(locationId: Scalars['ID']): ProductFeature;

  allowEnabling(locationId: Scalars['ID']): ProductFeature;

  analytics(locationId: Scalars['ID']): ProductFeature;

  accessDesksTab(locationId: Scalars['ID']): ProductFeature;

  csv(locationId: Scalars['ID']): ProductFeature;
}

export type ReservationFeatures = {
  enabled: boolean;

  view(locationId: Scalars['ID']): ProductFeature;

  booking(locationId: Scalars['ID']): ProductFeature;

  partialDayBooking(locationId: Scalars['ID']): ProductFeature;

  delegatedBooking(locationId: Scalars['ID']): ProductFeature;

  bookingHours(locationId: Scalars['ID']): ProductFeature;

  editing(locationId: Scalars['ID']): ProductFeature;

  checkingIn(locationId: Scalars['ID']): ProductFeature;

  canceling(locationId: Scalars['ID']): ProductFeature;

  autoAssignment(locationId: Scalars['ID']): ProductFeature;
}

export type RoomFeatures = {
  enabled: boolean;

  accessRoomsTab(locationId: Scalars['ID']): ProductFeature;

  unlimitedRooms: QuantityLimitedProductFeature;

  analytics(locationId: Scalars['ID']): ProductFeature;
}

export type RoomMeetingFeatures = {
  enabled: boolean;

  checkingIn(locationId: Scalars['ID']): ProductFeature;

  maskNames(locationId: Scalars['ID']): ProductFeature;

  notifications(locationId: Scalars['ID']): ProductFeature;

  onSiteRoomRecapture(locationId: Scalars['ID']): ProductFeature;

  recurringCleanup(locationId: Scalars['ID']): ProductFeature;

  resizer(locationId: Scalars['ID']): ProductFeature;
}

export type MapFeatures = {
  enabled: boolean;

  drafts(locationId: Scalars['ID']): ProductFeature;
}

export type FeatureConfig = {
  desks(locationId: Scalars['ID']): DeskFeatures;

  deskReservations(locationId: Scalars['ID']): ReservationFeatures;

  rooms(locationId: Scalars['ID']): RoomFeatures;

  roomMeetings(locationId: Scalars['ID']): RoomMeetingFeatures;

  deskAutoAssignment(locationId: Scalars['ID']): ProductFeature;
  deskCheckIn(locationId: Scalars['ID']): ProductFeature;
  desksActive(locationId: Scalars['ID']): ProductFeature;
  desksOnMaps(locationId: Scalars['ID']): ProductFeature;
  employeeRegistration(locationId: Scalars['ID']): ProductFeature;
  employeePrivateData(locationId: Scalars['ID']): ProductFeature;
  employeeScheduling(locationId: Scalars['ID']): ProductFeature;
  employeeSignInStatus(locationId: Scalars['ID']): ProductFeature;
  maps(locationId: Scalars['ID']): MapFeatures;
  mapsPointOfInterest(locationId: Scalars['ID']): ProductFeature;
  roomsOnMaps(locationId: Scalars['ID']): ProductFeature;
  schedulingLimits(locationId: Scalars['ID']): ProductFeature;
}

export type AdminConfig = {
  canViewAllReservations(locationId: Scalars['ID']): ProductFeature;
  canManageAllReservations(locationId: Scalars['ID']): ProductFeature;
}

export type GetFeatureConfigQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;

export type GetFeatureConfigQuery = {
  __typename?: 'Query';
  featureConfig: {
    __typename?: 'FeatureConfig';
    id: string;
    adminConfig: AdminConfig;
    desks: DeskFeatures;
    deskReservations: ReservationFeatures;
    deskAutoAssignment: ProductFeature;
    deskCheckIn: ProductFeature;
    desksActive: ProductFeature;
    desksOnMaps: ProductFeature;
    employeeRegistration: ProductFeature;
    employeePrivateData: ProductFeature;
    employeeScheduling: ProductFeature;
    employeeSignInStatus: ProductFeature;
    maps: MapFeatures;
    mapsPointOfInterest: ProductFeature;
    rooms: RoomFeatures;
    roomMeetings: RoomMeetingFeatures;
    roomsOnMaps: ProductFeature;
    schedulingLimits: ProductFeature;
  };
};
